import React from 'react';
import PropTypes from 'prop-types';
import { getVolumeAndBrightnessOptions } from '../../../../utils/configHelpers';

const MasterConfigSection = ({
  masterHardwareConfig,
  onHardwareChange,
  sending,
}) => {
  return (
    <div>
      <h6 className="text-muted small text-uppercase mb-3 font-weight-bold config-preview-section-title">
        Configuración Maestra
      </h6>
      <ul className="list-unstyled mb-3 text-dark small">
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Modo Debug:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.debug}
              onChange={(e) => onHardwareChange('master', 'debug', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Sonido Global:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.buzzer_master_enabled}
              onChange={(e) => onHardwareChange('master', 'buzzer_master_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Habilitar Electroimán:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.relay_enabled}
              onChange={(e) => onHardwareChange('master', 'relay_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Sensor Puerta:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.door_sensor_enabled}
              onChange={(e) => onHardwareChange('master', 'door_sensor_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Botón Emergencia:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.button_emergency_enabled}
              onChange={(e) => onHardwareChange('master', 'button_emergency_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Luz RGB:</span>
          <label className="custom-toggle-switch mb-0">
            <input
              type="checkbox"
              checked={!!masterHardwareConfig.rgb_enabled}
              onChange={(e) => onHardwareChange('master', 'rgb_enabled', e.target.checked)}
              disabled={sending}
            />
            <span className="toggle-slider"></span>
          </label>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Volumen Alarma:</span>
          <select
            value={masterHardwareConfig.buzzer_alarm_volume !== undefined ? masterHardwareConfig.buzzer_alarm_volume : 0}
            onChange={(e) => onHardwareChange('master', 'buzzer_alarm_volume', parseInt(e.target.value) || 0)}
            disabled={sending}
            className="config-select"
          >
            {getVolumeAndBrightnessOptions(masterHardwareConfig.buzzer_alarm_volume).map((val) => (
              <option key={val} value={val}>{val}</option>
            ))}
          </select>
        </li>
        <li className="d-flex justify-content-between align-items-center py-1 config-preview-item-border">
          <span>Brillo LED (RGB):</span>
          <select
            value={masterHardwareConfig.led_brightness !== undefined ? masterHardwareConfig.led_brightness : 0}
            onChange={(e) => onHardwareChange('master', 'led_brightness', parseInt(e.target.value) || 0)}
            disabled={sending}
            className="config-select"
          >
            {getVolumeAndBrightnessOptions(masterHardwareConfig.led_brightness).map((val) => (
              <option key={val} value={val}>{val}</option>
            ))}
          </select>
        </li>
      </ul>
    </div>
  );
};

MasterConfigSection.propTypes = {
  masterHardwareConfig: PropTypes.object.isRequired,
  onHardwareChange: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default MasterConfigSection;
